<template>
  <div class="login-content">
    <div class="qc-position-center login-card">
      <LoginCard identity="cms" />
      <div class="text-center pt-4 text-white">
        <b-link :href="userUrl" class="text-white">會員登入</b-link>
        ｜
        <b-link :href="manageUrl" class="text-white">管理者登入</b-link>
      </div>
      <div class="text-center pt-4 text-white" style="font-size: 14px;">
        © {{ new Date().getFullYear() }} Quarter Car Part.版權所有。
        <span class="pl-2">v{{ version }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.background {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(0deg, #007b4f, #73da6c);
}
</style>

<script>
import LoginCard from "@/components/auth/Login.vue";

export default {
  name: "CMS_Login",
  components: {
    LoginCard
  },
  data() {
    return {
      userUrl: "",
      manageUrl: "",
      isDev: false,
      version: process.env.VUE_APP_VERSION
    };
  },
  created() {
    if (
      window.location.hostname === "localhost" ||
      window.location.hostname === "coding-it.gitlab.io"
    ) {
      this.isDev = true;
    }
    if (this.isDev) {
      this.userUrl = "/login";
      this.manageUrl = "/manage/login";
    } else {
      this.userUrl = process.env.VUE_APP_USER_URL;
      this.manageUrl = process.env.VUE_APP_MANAGE_URL;
    }
  },
  mounted() {
    document.querySelector("body").className = "";
    document.querySelector("body").classList.add(this.$style["background"]);
  }
};
</script>
